import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import paymentModeFormFields, { paymentModeSaveUrl } from '@form/paymentModeFormFields'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { updateNotification } from '@store/slice/mainSlice'
import { updatePaymentModeFormObject, updatePaymentModes, updateErrors, initPaymentModeFormObject } from '@store/slice/paymentSlice'
import { useEffect } from 'react'
import { post } from '@util/xhrAPI'
import { ROLE_SUPER_ADMIN } from '@router/Routes'
import useStoreUpdate from '@hook/useStoreUpdate'
import useFormData from '@hook/useFormData'
import Form from '@ui/elements/Form'
import useToggle from '@hook/useToggle'

const EditPaymentMode = () => {
  const { paymentModeFormObject, errors, paymentModes } = useSelector(state => state.payment)
  const { mission } = useSelector(state => state.main)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isLoading, toggleLoading] = useToggle(false)
  const [t] = useTranslation('payment')
  const renderFormData = useFormData()
  const [updateFormObject, updateFormObjectProp] = useStoreUpdate(dispatch, updatePaymentModeFormObject, paymentModeFormObject)


  const saveForm = e => {
    toggleLoading()
    e.preventDefault()
    let formObject = {
      ...paymentModeFormObject,
      mission: mission.id
    }
    post(paymentModeSaveUrl, renderFormData(formObject, ['liveConfig']), response => {
      const { code, errors, paymentMode } = response
      if (code === 200) {
        dispatch(updatePaymentModes({ ...paymentModes, [paymentMode.id]: { ...paymentMode } }))
        dispatch(updateNotification({ type: 'is-success', message: t('notifications.payment_mode_saved') }))
        backToList()
      }
      if (Object.keys(errors).length) {
        dispatch(updateErrors(errors))
      }
      toggleLoading()
    })
  }

  const generateFormStep = step => {
    return paymentModeFormFields(step, paymentModeFormObject, updateFormObject, updateFormObjectProp, saveForm, errors, isLoading, t)
  }


  const backToList = () => {
    dispatch(initPaymentModeFormObject())
    navigate(ROLE_SUPER_ADMIN['paymentModes'])
  }

  useEffect(() => {
    updatePaymentModes({ ...paymentModes })
  }, [])

  return (
    <Div cssClass='create-payment-mode-zone form columns is-multiline'>
      <Buttons buttons={
        {
          cssClass: 'back-to-list is-info is-small',
          callback: backToList,
          text: t('actions.back_to_payment_modes_list'),
          icon: 'icon-keyboard_arrow_left'
        }
      } />
      <Div cssClass='form-header'>
        <h2>{t('titles.payment_mode_creation')}</h2>
      </Div>
      <Form>
        <Div cssClass='columns is-multiline'>
          <Div cssClass='column is-6 payment-mode-form-bloc'>
            <h4 className='block-title'></h4>
            {generateFormStep('common')}
          </Div>
          {
            <Div cssClass='column is-6 payment-mode-form-bloc'>
              <h4 className='block-title'></h4>
              {paymentModeFormObject.code && generateFormStep(paymentModeFormObject.code)}
            </Div>
          }
          <Div cssClass='column is-12 payment-mode-form-bloc'>
            {generateFormStep('submit')}
          </Div>
        </Div>
      </Form>
    </Div>
  )
}

export default EditPaymentMode